const apiUrl =
    process.env.REACT_APP_API_URL || 'localhost:3008';

// `apiUrl` is a host, not a URL — the protocol is derived rather than
// configured, because local development is the only place that is not HTTPS.
// Exported so the Apollo links and the REST auth calls cannot drift apart.
export const apiHttpUrl = `${
    apiUrl.startsWith('localhost') ? 'http' : 'https'
}://${apiUrl}`;

export const apiWsUrl = `${
    apiUrl.startsWith('localhost') ? 'ws' : 'wss'
}://${apiUrl}`;

export default apiUrl;
